import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox } from '@cian/ui-kit';
import { selectBalance, selectIsUseBalanceFunds, selectPrice } from '../../../selectors/checkout';
import { selectIsPaymentAmountVisible, selectIsUseBalanceFundsVisible } from '../../../selectors/layout';
import { setUseBalanceFunds } from '../../../actions/checkout';
import { NBSP } from '../../../constants/symbols';
import { formatMoney } from '../../../utils/string';
import { PaymentAmount } from './PaymentAmount';

export const PaymentAmountContainer = () => {
  const price = useSelector(selectPrice);
  const balance = useSelector(selectBalance);
  const isUseBalanceFunds = useSelector(selectIsUseBalanceFunds);
  const isVisible = useSelector(selectIsPaymentAmountVisible);
  const isUseBalanceFundsVisible = useSelector(selectIsUseBalanceFundsVisible);

  const dispatch = useDispatch();

  const handleFromBalanceChange = React.useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      dispatch(setUseBalanceFunds(value));
    },
    [dispatch],
  );

  if (!isVisible) {
    return null;
  }

  const checkbox = isUseBalanceFundsVisible && (
    <Checkbox
      label={`Списать с${NBSP}баланса ${formatMoney(balance)}`}
      checked={isUseBalanceFunds}
      onChange={handleFromBalanceChange}
      data-testid="widget|checkbox|useBalance"
    />
  );

  return <PaymentAmount price={price} checkbox={checkbox} />;
};
